export function SkeletonCard() {
    return (
        <div className="rounded-2xl border border-border bg-card p-4">
            <div className="h-3 w-24 bg-muted animate-pulse rounded" />
            <div className="h-6 w-32 bg-muted animate-pulse rounded mt-2" />
        </div>
    );
}

export function SkeletonRow() {
    return (
        <div className="flex items-center gap-3 p-3 rounded-2xl bg-card border border-border">
            <div className="h-11 w-11 rounded-xl bg-muted animate-pulse" />
            <div className="flex-1">
                <div className="h-3 w-32 bg-muted animate-pulse rounded" />
                <div className="h-3 w-20 bg-muted animate-pulse rounded mt-2" />
            </div>
            <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        </div>
    );
}

export function EmptyState({ title = "Belum ada data", description, icon, action }) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-12 px-4">
            <div className="h-16 w-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
                {icon}
            </div>
            <div className="font-heading font-semibold text-lg">{title}</div>
            {description && <div className="text-sm text-muted-foreground mt-1 max-w-xs">{description}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
